"use strict";
checkList.service('CheckListService', function(AlertService, ApplicationService, authServiceFactory)
{
    this.alerts = {};
    this.flags = {};
    this.counts = []; //total and completed counts of flags 
    this.complete = {interest: [], policy: []}; //interest and policy flags
    this.interestSelected = {};

    this.init = function() {
    	this.initAlerts();
    	this.initFlags();
    	this.getTotals();
    };
    this.initAlerts = function () {
        this.alerts = AlertService.getBothAlerts();
    };
    this.initFlags = function() {
        this.flags = ApplicationService.getAwardData().flags;
        this.ismFlags = ApplicationService.getAwardData().td;
    };
    this.initSelected = function() {
        this.interestSelected = {};
    };
    this.getTotals = function() {

        //-------- Get Totals ---------

        //Confidential
        if (authServiceFactory.getAuth().permissions.confidential==1) {
            // for each family
            for (var fam in this.alerts) {
                fam = parseInt(fam);
                this.counts[fam] = {
                    total : {process: 0, award: 2},
                    complete : {process: 0, award: 0}
                };

                this.counts[fam].total.process++;
                if (ApplicationService.getFamilyData(fam).apWizard.viewedFamily==1)
                    this.counts[fam].complete.process++;

                //if app has been awarded
                if (ApplicationService.getAwardData().app[0].Status_Award==1 
                    || ApplicationService.getAwardData().app[0].Status_Consider==1
                    || ApplicationService.getAwardData().app[0].Status_Reject==1) {
                        this.counts[fam].complete.award += 2;
                }

            }
        }

        //Non-confidential
        if (authServiceFactory.getAuth().permissions.confidential==0) {
            // for each family
            for (var fam in this.alerts) {
                fam = parseInt(fam);
                this.counts[fam] = {
                    total : {policy: 0, interest: 0, process: 0, award: 2},
                    complete : {policy: 0, interest: 0, process: 0, award: 0}
                };

                // Add totals for income change, added allowance
                for(var key in this.alerts[fam]) {
                    if (this.alerts[fam][key].state==="danger")
                        this.counts[fam].total.policy++;
                    else if (this.alerts[fam][key].state==="warning" && (key !== "incomeChange" && key !== "addedAllowance" && key !== "percentTuition"))
                        this.counts[fam].total.policy++;
                    else if (this.alerts[fam][key].state==="success" && (key !== "incomeChange" && key !== "addedAllowance" && key !== "percentTuition")) {
                        this.counts[fam].total.policy++;
                        this.counts[fam].complete.policy++;
                    }
                }

                // add totals for user defined rejection flags as policy
                for(var f in this.flags["family"+(fam+1)].rejection) {
                    if (this.flags["family"+(fam+1)].rejection[f].weight>0 || this.flags["family"+(fam+1)].rejection[f].weight==null) {
                        this.counts[fam].total.interest++;
                        if (this.flags["family"+(fam+1)].rejection[f].complete==1) {
                            this.counts[fam].complete.interest++;
                        }
                    }
                }

                // add totals for user defined caution flags as interest
                for(var f in this.flags["family"+(fam+1)].caution) {
                    if (this.flags["family"+(fam+1)].caution[f].weight>0 || this.flags["family"+(fam+1)].caution[f].weight==null) {
                        this.counts[fam].total.interest++;
                        if (this.flags["family"+(fam+1)].caution[f].complete==1) {
                            this.counts[fam].complete.interest++;
                        }
                    }
                }

                this.counts[fam].total.process++;
                if (ApplicationService.getFamilyData(fam).apWizard.viewedFamily==1)
                    this.counts[fam].complete.process++;

                // has the fam letter been read?
                if (ApplicationService.getFamilyData(fam).data[0].Fam_Letter) {
                    this.counts[fam].total.process++;
                    if (ApplicationService.getFamilyData(fam).apWizard.viewedLetter==1)
                        this.counts[fam].complete.process++;
                }

                // has the fam letter been read?
                if (ApplicationService.getFamilyData(fam).extraQuestionsAnswers.length>0) {
                    this.counts[fam].total.process++;
                    if (ApplicationService.getFamilyData(fam).apWizard.viewedSsq==1)
                        this.counts[fam].complete.process++;
                }

                //if there are descriptions for award data, has the other descriptions been read?
                if (
                    (ApplicationService.getFamilyData(fam).edit_sums.Inc_Business>0 && ApplicationService.getFamilyData(fam).income.Inc_Business_Desc!='')
                    || (ApplicationService.getFamilyData(fam).edit_sums.Inc_Other>0 && ApplicationService.getFamilyData(fam).income.Inc_Other_Desc!='')
                    || (ApplicationService.getFamilyData(fam).edit_sums.Exp_Med_Val>0 && ApplicationService.getFamilyData(fam).income.Exp_Med_Desc!='')
                    || (ApplicationService.getFamilyData(fam).edit_sums.Exp_Loan_Val>0 && ApplicationService.getFamilyData(fam).income.Exp_Load_Desc!='')
                    || (ApplicationService.getFamilyData(fam).edit_sums.Exp_Dep_Val>0 && ApplicationService.getFamilyData(fam).income.Exp_Dep_Desc!='')
                    || (ApplicationService.getFamilyData(fam).edit_sums.Exp_Childcare_Val>0 && ApplicationService.getFamilyData(fam).income.Exp_Childcard_Desc!='')
                    || (ApplicationService.getFamilyData(fam).edit_sums.Exp_Other_Val>0 && ApplicationService.getFamilyData(fam).income.Exp_Other_Desc!='')
                    || (ApplicationService.getFamilyData(fam).edit_sums.Asset_Bus_Val>0 && ApplicationService.getFamilyData(fam).income.Asset_Bus_Desc!='')
                    || (ApplicationService.getFamilyData(fam).edit_sums.Asset_Other_Val>0 && ApplicationService.getFamilyData(fam).income.Asset_Other_Desc!='')
                    || (ApplicationService.getFamilyData(fam).edit_sums.Liab_Other_Val>0 && ApplicationService.getFamilyData(fam).income.Liab_Other_Desc!='')
                    ) {
                        this.counts[fam].total.process++;
                        if (ApplicationService.getFamilyData(fam).apWizard.viewedOtherDesc==1)
                            this.counts[fam].complete.process++;
                }

                // total the truth detector flags
                for (var i in this.ismFlags[fam]) {
                    // total td process flags
                    if (this.ismFlags[fam][i].class=='process') {
                        this.counts[fam].total.process++;
                        if (this.ismFlags[fam][i].complete!==undefined && this.ismFlags[fam][i].complete==1)
                            this.counts[fam].complete.process++;
                    }
                    // total td interest flags if 
                    else if (this.ismFlags[fam][i].class=='interest') {
                        this.counts[fam].total.interest++;
                        if (this.ismFlags[fam][i].complete!==undefined && this.ismFlags[fam][i].complete==1)
                            this.counts[fam].complete.interest++;
                    }

                }

                //if app has been awarded
                if (ApplicationService.getAwardData().app[0].Status_Award==1 
                    || ApplicationService.getAwardData().app[0].Status_Consider==1
                    || ApplicationService.getAwardData().app[0].Status_Reject==1) {
                        this.counts[fam].complete.award += 2;
                }

            }
        }
        
    };
    this.resetItems = function(fam) {
        for(var f in this.flags["family"+(fam+1)].caution) {
            this.flags["family"+(fam+1)].caution[f].complete=0
            this.flags["family"+(fam+1)].caution[f].weight=1
        }
        for(var f in this.flags["family"+(fam+1)].rejection) {
            this.flags["family"+(fam+1)].rejection[f].complete=0
            this.flags["family"+(fam+1)].rejection[f].weight=1
        }
        for(var f in this.ismFlags[fam]) {
            this.ismFlags[fam][f].complete=0
            this.ismFlags[fam][f].schoolweight=null
        }
    };
    this.isComplete = function(fam) {
        return this.counts[fam] 
            && this.counts[fam].complete.process===this.counts[fam].total.process
            && this.counts[fam].complete.interest===this.counts[fam].total.interest
            && this.counts[fam].complete.policy===this.counts[fam].total.policy;
    };


    return this;
});
